import { StandardEvents } from '@shopify/events';

/**
 * A custom element that keeps the product download box (Schnittzeichnung,
 * Ausschreibungstext, etc.) in sync with the currently selected variant,
 * without a full page reload.
 */
class ProductDownloadBoxComponent extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    this.closestSection = closestSection;
    closestSection.addEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  disconnectedCallback() {
    this.closestSection?.removeEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  handleProductSelect = (event) => {
    event.promise
      .then(({ detail }) => {
        if (!detail?.html || !this.id) return;
        const newBox = detail.html.querySelector(`#${this.id}`);
        if (newBox) {
          this.innerHTML = newBox.innerHTML;
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-download-box] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-download-box-component')) {
  customElements.define('product-download-box-component', ProductDownloadBoxComponent);
}
